import React from "react";
import { ArrowRight } from "lucide-react";
import useTechCopy from "../useTechCopy";
import ShinyText from "../ui/ShinyText";

// Closes the page the way it opened: a centred two-line headline with the
// shine on the second line, and one action.
export default function CTASection() {
  const copy = useTechCopy().cta;

  return (
    <section id="contact" className="relative bg-black px-6 sm:px-10 lg:px-16 py-32 lg:py-44">
      <div className="max-w-[1600px] mx-auto flex flex-col items-center text-center">
        <h2 className="font-medium tracking-tighter leading-[0.9] text-[clamp(2.75rem,7vw,7rem)]">
          <span className="block text-white">{copy.title[0]}</span>
          <ShinyText text={copy.title[1]} className="block py-[0.2em] -my-[0.2em]" />
        </h2>

        <p className="mt-8 max-w-md text-base lg:text-lg leading-relaxed text-white/80">{copy.lede}</p>

        <a
          href={`mailto:${copy.email}`}
          className="group mt-10 inline-flex items-center gap-2 rounded-full bg-white text-black hover:bg-white/90 px-6 md:px-8 py-3 md:py-4 text-sm md:text-base font-medium transition-colors duration-300"
        >
          {copy.button}
          <ArrowRight
            className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
            aria-hidden="true"
          />
        </a>
        <a
          href={`mailto:${copy.email}`}
          className="mt-5 text-white/60 hover:text-white transition-colors duration-300"
        >
          {copy.email}
        </a>

        <p className="mt-16 text-sm text-white/50">{copy.note}</p>
      </div>
    </section>
  );
}
